export const RESET = 'CONTACTTYPE_LIST_RESET'
export const SET_ITEMS = 'CONTACTTYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'CONTACTTYPE_LIST_SET_ERROR'
export const SET_VIEW = 'CONTACTTYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'CONTACTTYPE_LIST_TOGGLE_LOADING'
